export function getDefaultActionCellProps() {
  return {
    appendTo: 'window' as const,
    placement: 'auto' as const,
  };
}
